export class CalculatorInputsDTO {
    strategyType: string;
    allocationAmount: number;
    term: number;
    bufferLevel: number;
    index: string;
    productCode: string;
    
    constructor(strategyType: string,
        allocationAmount: number,
        term: number,
        bufferLevel: number,
        index: string, 
        productCode: string
    ) {
        this.strategyType = strategyType;
        this.allocationAmount = allocationAmount;
        this.term = term;
        this.bufferLevel = bufferLevel;
        this.index = index;
        this.productCode = productCode;
    }
}